import React from 'react';

import type { FacebookPostComponentsProps } from './types';

export function Body(_props: FacebookPostComponentsProps): React.JSX.Element {
	return <div>Facebook Post Body</div>;
}
